import { useEffect, useState } from 'react';

const useWindowSize = () => {

  const [windowSize, setWindowSize] = useState({ windowW: window.innerWidth, windowH: window.innerHeight });

  useEffect(() => {
    const handleResize = () => { setWindowSize({ windowW: window.innerWidth, windowH: window.innerHeight }) };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const W = windowSize.windowW;
  const H = windowSize.windowH;
  const screenRatio = W/H;
  const onMobile = W < 768;
  const onDesk = W > 1200;

  return {
    W,
    H,
    screenRatio,
    onMobile,
    onDesk
  }
}

export default useWindowSize;